import { render, staticRenderFns } from "./WaitlistForm.vue?vue&type=template&id=6e656a35&scoped=true&"
import script from "./WaitlistForm.vue?vue&type=script&lang=js&"
export * from "./WaitlistForm.vue?vue&type=script&lang=js&"
import style0 from "./WaitlistForm.vue?vue&type=style&index=0&id=6e656a35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e656a35",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VForm,VTextField})
